import { Component, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MultiShipmentExtension } from '@pdqdev/pdq-shared/dist/interfaces/ICheckoutExtensions';
import { ShippingToggleForm } from '../../model';

@Component({
  selector: 'multi-shipment-shipping-toggle',
  templateUrl: './shipping-toggle.component.html',
  styleUrls: ['./shipping-toggle.component.scss'],
  standalone: false,
})
export class ShippingToggleComponent {
  @Input({ required: true }) formGroup!: FormGroup<ShippingToggleForm>;

  get singleAddressTitleControl(): FormControl<string> {
    return this.formGroup.controls.singleAddress.controls.title;
  }

  get multiAddressTitleControl(): FormControl<string> {
    return this.formGroup.controls.multiAddress.controls.title;
  }

  get singleAddressControl(): FormControl<string> {
    return this.formGroup.controls.singleAddress.controls.description;
  }

  get multiAddressControl(): FormControl<string> {
    return this.formGroup.controls.multiAddress.controls.description;
  }

  setDefault(mode: MultiShipmentExtension.ShippingMode): void {
    this.formGroup.controls.defaultSelection.setValue(mode);
    this.formGroup.controls.defaultSelection.markAsDirty();
  }
}
